const templateUrl = require('./views/shipment-date-select-modal.html');

const inject = ['$state', 'analytics', 'shipmentOrchestrator', '$uibModal', 'dialogService', 'toastService', '$document', 'ogDateFilter'];

function ChangeShipmentDateControllerFactory($state, analytics, shipmentOrchestrator, $uibModal, dialogService, toastService, $document, ogDateFilter) {
  class ChangeShipmentDateController {
    openDateSelectModal() {
      analytics.logEvent('click', 'Change Shipment Date');

      const modal = $uibModal.open({
        templateUrl: templateUrl,
        controller: 'ShipmentDateSelectController',
        controllerAs: '$ctrl',
        size: 'md',
        resolve: {
          selectedDate: () => new Date(this.shipment.place)
        },
        windowTopClass: 'og-change-shipment-date-modal',
        ariaLabelledBy: 'og-change-shipment-date-modal-title'
      });

      modal.rendered.then(() => $document[0].querySelector('.og-modal-window').setAttribute('aria-modal', true));

      modal.result = modal.result
        .then(newDate => this.changeShipmentDate(this.shipment.publicId, newDate))
        .catch(dialogService.supressModalCloseReject);

      return modal;
    }

    changeShipmentDate(shipmentId, placeDate) {
      const parseDate = parseToGMTDate(placeDate);
      return shipmentOrchestrator.changeShipmentDate(shipmentId, parseDate)
        .then(() => {
          const placeDateStr = ogDateFilter(placeDate, 'll');
          toastService.translate.success('TOAST_CHANGE_DATE_SUCCESS', { placeDate: placeDateStr });
        })
        .then($state.reload)
        .catch(() => toastService.translate.danger('TOAST_CHANGE_DATE_DANGER'));
    }
  }

  return new ChangeShipmentDateController();

  function parseToGMTDate(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  }
}

ChangeShipmentDateControllerFactory.$inject = inject;

const app = angular.module('msi.shipments.changeShipmentDate.controller', []);

app.controller('ChangeShipmentDateController', ChangeShipmentDateControllerFactory);

module.exports = app.name;
